"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeepLinkImpressionTrack = void 0;
const common_snap_ad_impression_track_1 = require("./common_snap_ad_impression_track");
const remote_webpage_impression_track_1 = require("./remote_webpage_impression_track");
const app_install_impression_track_1 = require("./app_install_impression_track");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
function createBaseDeepLinkImpressionTrack() {
    return {
        commonSnapAdImpression: undefined,
        deepLinkedToAppCount: undefined,
        deepLinkedToAppInstallCount: undefined,
        deepLinkFallbackToWebview: undefined,
        deeplinkUri: "",
        customProductPageEnabled: undefined,
        deepLinkFallbackToDefaultBrowser: undefined,
        remoteWebpageImpressionTrack: undefined,
        appInstallStatus: 0,
        appInstall: undefined,
    };
}
exports.DeepLinkImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.commonSnapAdImpression !== undefined) {
            common_snap_ad_impression_track_1.CommonSnapAdImpressionTrack.encode(message.commonSnapAdImpression, writer.uint32(10).fork()).ldelim();
        }
        if (message.deepLinkedToAppCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.deepLinkedToAppCount }, writer.uint32(18).fork()).ldelim();
        }
        if (message.deepLinkedToAppInstallCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.deepLinkedToAppInstallCount }, writer.uint32(26).fork()).ldelim();
        }
        if (message.deepLinkFallbackToWebview !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.deepLinkFallbackToWebview }, writer.uint32(34).fork()).ldelim();
        }
        if (message.deeplinkUri !== "") {
            writer.uint32(42).string(message.deeplinkUri);
        }
        if (message.customProductPageEnabled !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.customProductPageEnabled }, writer.uint32(50).fork()).ldelim();
        }
        if (message.deepLinkFallbackToDefaultBrowser !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.deepLinkFallbackToDefaultBrowser }, writer.uint32(58).fork()).ldelim();
        }
        if (message.remoteWebpageImpressionTrack !== undefined) {
            remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.encode(message.remoteWebpageImpressionTrack, writer.uint32(66).fork()).ldelim();
        }
        if (message.appInstallStatus !== 0) {
            writer.uint32(72).int32(message.appInstallStatus);
        }
        if (message.appInstall !== undefined) {
            app_install_impression_track_1.AppInstallImpressionTrack.encode(message.appInstall, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeepLinkImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commonSnapAdImpression = common_snap_ad_impression_track_1.CommonSnapAdImpressionTrack.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.deepLinkedToAppCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.deepLinkedToAppInstallCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.deepLinkFallbackToWebview = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.deeplinkUri = reader.string();
                    break;
                case 6:
                    message.customProductPageEnabled = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.deepLinkFallbackToDefaultBrowser = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.remoteWebpageImpressionTrack =
                        remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.appInstallStatus = reader.int32();
                    break;
                case 10:
                    message.appInstall = app_install_impression_track_1.AppInstallImpressionTrack.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDeepLinkImpressionTrack();
        message.commonSnapAdImpression =
            object.commonSnapAdImpression !== undefined &&
                object.commonSnapAdImpression !== null
                ? common_snap_ad_impression_track_1.CommonSnapAdImpressionTrack.fromPartial(object.commonSnapAdImpression)
                : undefined;
        message.deepLinkedToAppCount = object.deepLinkedToAppCount ?? undefined;
        message.deepLinkedToAppInstallCount =
            object.deepLinkedToAppInstallCount ?? undefined;
        message.deepLinkFallbackToWebview =
            object.deepLinkFallbackToWebview ?? undefined;
        message.deeplinkUri = object.deeplinkUri ?? "";
        message.customProductPageEnabled =
            object.customProductPageEnabled ?? undefined;
        message.deepLinkFallbackToDefaultBrowser =
            object.deepLinkFallbackToDefaultBrowser ?? undefined;
        message.remoteWebpageImpressionTrack =
            object.remoteWebpageImpressionTrack !== undefined &&
                object.remoteWebpageImpressionTrack !== null
                ? remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.fromPartial(object.remoteWebpageImpressionTrack)
                : undefined;
        message.appInstallStatus = object.appInstallStatus ?? 0;
        message.appInstall =
            object.appInstall !== undefined && object.appInstall !== null
                ? app_install_impression_track_1.AppInstallImpressionTrack.fromPartial(object.appInstall)
                : undefined;
        return message;
    },
};
//# sourceMappingURL=deep_link_impression_track.js.map